import React from 'react';
import { ExternalLink, ShieldAlert } from 'lucide-react';
import { motion } from 'framer-motion';
export function ThreeDayGuarantee() {
  return <section id="3-day-guarantee" className="py-20 md:py-32 px-6 bg-navy relative overflow-hidden" data-id="element-405">
      {/* Background accents */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-406">
        <div className="absolute -top-40 -right-40 w-96 h-96 bg-blue/30 rounded-full blur-3xl" data-id="element-407"></div>
        <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-teal/20 rounded-full blur-3xl" data-id="element-408"></div>
      </div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-409">
        <div className="grid lg:grid-cols-12 gap-16 items-center" data-id="element-410">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} className="lg:col-span-5 flex flex-col gap-8" data-id="element-411">
            <div className="inline-flex items-center gap-2 bg-yellow text-navy px-4 py-2 rounded-full text-sm font-extrabold w-fit shadow-lg transform -rotate-2" data-id="element-412">
              <ShieldAlert size={18} data-id="element-413" />
              NEW 2026 POLICY
            </div>
            <h2 className="text-3xl md:text-5xl font-extrabold text-white leading-[1.1] tracking-tight" data-id="element-414">
              The 3 Day Guarantee starts now — your family qualifies for 3
              subsidised days a week.
            </h2>
            <div className="space-y-4" data-id="element-415">
              <p className="text-lg md:text-xl text-white/80 font-medium leading-relaxed" data-id="element-416">
                From 5 January 2026, every CCS-eligible family with a household
                income under $530,000 gets 72 subsidised hours per fortnight —
                that's 3 full days a week — automatically.
              </p>
              <p className="text-xl text-yellow font-bold" data-id="element-417">
                Stay-at-home parents who used to get 0 or 1 day now get 3.
              </p>
            </div>

            <div className="flex flex-col gap-4 mt-2" data-id="element-418">
              <a href="#ccs-calculator" className="bg-teal text-white px-8 py-4 rounded-btn font-bold text-lg hover:bg-teal/90 transition-colors text-center shadow-lg hover:-translate-y-1 transform duration-200" data-id="element-419">
                Calculate my exact CCS-net price
              </a>
              <div className="flex flex-col sm:flex-row gap-4" data-id="element-420">
                <a href="#contact" className="flex-1 bg-white/10 backdrop-blur-sm border border-white/20 text-white px-6 py-4 rounded-btn font-bold hover:bg-white/20 transition-colors text-center" data-id="element-421">
                  Ask us about CCS
                </a>
                <a href="#tours" className="flex-1 bg-white/10 backdrop-blur-sm border border-white/20 text-white px-6 py-4 rounded-btn font-bold hover:bg-white/20 transition-colors text-center" data-id="element-422">
                  Book a tour to talk
                </a>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} className="lg:col-span-7" data-id="element-423">
            <div className="bg-white rounded-[24px] shadow-2xl overflow-hidden border-t-8 border-yellow" data-id="element-424">
              <div className="p-8 border-b border-sand bg-cream" data-id="element-425">
                <h3 className="font-extrabold text-navy text-xl" data-id="element-426">
                  The math, worked through for Funtastic Kidz
                </h3>
              </div>
              <div className="overflow-x-auto hide-scrollbar" data-id="element-427">
                <table className="w-full text-left border-collapse min-w-[600px]" data-id="element-428">
                  <thead data-id="element-429">
                    <tr className="border-b border-sand bg-white" data-id="element-430">
                      <th className="py-5 px-6 font-bold text-navy text-sm uppercase tracking-wider" data-id="element-431">
                        Income band
                      </th>
                      <th className="py-5 px-6 font-bold text-navy/60 text-sm uppercase tracking-wider" data-id="element-432">
                        Old subsidy
                      </th>
                      <th className="py-5 px-6 font-bold text-teal text-sm uppercase tracking-wider bg-teal-light/30" data-id="element-433">
                        New (3 Day Guarantee)
                      </th>
                      <th className="py-5 px-6 font-bold text-navy text-sm uppercase tracking-wider" data-id="element-434">
                        Weekly out-of-pocket (3 days)
                      </th>
                    </tr>
                  </thead>
                  <tbody className="text-base" data-id="element-435">
                    <tr className="border-b border-sand/50 hover:bg-sand/10 transition-colors" data-id="element-436">
                      <td className="py-5 px-6 text-navy font-bold" data-id="element-437">
                        Under $80,594
                      </td>
                      <td className="py-5 px-6 text-navy/50 font-medium line-through" data-id="element-438">
                        up to 90%
                      </td>
                      <td className="py-5 px-6 text-teal font-bold bg-teal-light/30" data-id="element-439">
                        up to 90%
                      </td>
                      <td className="py-5 px-6 text-navy font-medium" data-id="element-440">
                        from around{' '}
                        <strong className="text-coral text-xl" data-id="element-441">$35.40</strong>
                      </td>
                    </tr>
                    <tr className="border-b border-sand/50 hover:bg-sand/10 transition-colors" data-id="element-442">
                      <td className="py-5 px-6 text-navy font-bold" data-id="element-443">
                        $80,594-$190,000
                      </td>
                      <td className="py-5 px-6 text-navy/50 font-medium line-through" data-id="element-444">
                        sliding
                      </td>
                      <td className="py-5 px-6 text-teal font-bold bg-teal-light/30" data-id="element-445">
                        sliding
                      </td>
                      <td className="py-5 px-6 text-navy font-medium" data-id="element-446">
                        from around{' '}
                        <strong className="text-coral text-xl" data-id="element-447">$70-$140</strong>
                      </td>
                    </tr>
                    <tr className="border-b border-sand/50 hover:bg-sand/10 transition-colors" data-id="element-448">
                      <td className="py-5 px-6 text-navy font-bold" data-id="element-449">
                        $190,000-$530,000
                      </td>
                      <td className="py-5 px-6 text-navy/50 font-medium line-through" data-id="element-450">
                        tapered
                      </td>
                      <td className="py-5 px-6 text-teal font-extrabold bg-teal-light/30" data-id="element-451">
                        minimum 3 days
                      </td>
                      <td className="py-5 px-6 text-navy font-medium" data-id="element-452">
                        from around{' '}
                        <strong className="text-coral text-xl" data-id="element-453">
                          $170-$285
                        </strong>
                      </td>
                    </tr>
                    <tr className="hover:bg-sand/10 transition-colors" data-id="element-454">
                      <td className="py-5 px-6 text-navy font-bold" data-id="element-455">
                        Over $530,000
                      </td>
                      <td className="py-5 px-6 text-navy/50 font-medium" data-id="element-456">
                        nil
                      </td>
                      <td className="py-5 px-6 text-navy/50 font-medium bg-teal-light/30" data-id="element-457">
                        nil
                      </td>
                      <td className="py-5 px-6 text-navy font-medium" data-id="element-458">
                        $354 (full rate)
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="p-6 bg-cream border-t border-sand text-sm text-navy/70 space-y-3" data-id="element-459">
                <p className="font-medium" data-id="element-460">
                  <strong data-id="element-461">Important honest note:</strong> these are illustrative
                  examples. Your actual subsidy depends on family income,
                  activity hours, child age, and CCS eligibility.{' '}
                  <span className="text-navy/40 font-normal" data-id="element-462">
                    Subsidy bands current as at January 2026.
                  </span>
                </p>
                <a href="https://www.education.gov.au/early-childhood/providers/child-care-subsidy/3-day-guarantee" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 text-blue font-bold hover:text-blue-deep transition-colors" data-id="element-463">
                  Australian Department of Education — 3 Day Guarantee{' '}
                  <ExternalLink size={14} data-id="element-464" />
                </a>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}